import React, { useState } from 'react';
import { Container, Paper, Tabs, Tab, Box, Typography } from '@mui/material';
import Layout from '../components/Layout';
import EmailCampaigns from '../components/EmailCampaigns';
import EmailSends from '../components/EmailSends';
import EmailTemplate from '../components/EmailTemplate';

const Email = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Layout>
      <Container maxWidth={false} sx={{ width: '100%' }}>
        <Typography variant="h4" gutterBottom fontWeight={700} sx={{ mb: 2 }}>
          Email
        </Typography>
        <Paper sx={{ p: 3 }}>
          <Tabs value={tabValue} onChange={handleTabChange} sx={{ mb: 3 }}>
            <Tab label="Campaigns" />
            <Tab label="Email Sends" />
            <Tab label="Template" />
          </Tabs>
          <Box>
            {tabValue === 0 && <EmailCampaigns />}
            {tabValue === 1 && <EmailSends />}
            {tabValue === 2 && <EmailTemplate />}
          </Box>
        </Paper>
      </Container>
    </Layout>
  );
};

export default Email;



